import { Box, Text } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { PLAN_TEXT } from 'pages/PlanRevamp/PlanPageUIRevamp/planPageRevampUi';
import {
  handleActionStepNext,
  resetMultipleIndicatorsType,
  setSingleIndicatorValue,
} from 'redux/DataImportSlice';
import { getBlockInputIndicator } from 'redux/PlanPageSlice';

import colors from '../../../dataTheme';
import ActionStepFooter from '../../ActionStepFooter';
import { FieldError, FieldLabel, StepFooterRow, StepSelect } from '../../actionStepUi';

const validationSchema = Yup.object().shape({
  singleIndicatorValue: Yup.string().required('Indicator value is required'),
});

interface Properties {
  getFormValue: any;
}

const SingleIndWoCol = ({ getFormValue }: Properties) => {
  const dispatch: any = useDispatch();
  const inputIndicator = useSelector(getBlockInputIndicator);

  const handleSubmit = (form: any, setSubmitting: (data: boolean) => void) => {
    dispatch(setSingleIndicatorValue(form)).then(() => {
      dispatch(resetMultipleIndicatorsType());
      setSubmitting(false);
      dispatch(handleActionStepNext());
    });
  };

  return (
    <Box w='100%' mt={4}>
      <Formik
        initialValues={{
          singleIndicatorValue: getFormValue?.singleIndicatorValue || '',
        }}
        validationSchema={validationSchema}
        onSubmit={(form, { setSubmitting }) => handleSubmit(form, setSubmitting)}
        enableReinitialize={true}
      >
        {({ values, errors, setFieldValue, isSubmitting }: any) => (
          <Form style={{ width: '100%' }}>
            <FieldLabel>What indicator are you importing into the Block?</FieldLabel>
            {inputIndicator?.length > 0 && (
              <>
                <StepSelect
                  value={values.singleIndicatorValue}
                  placeholder='Select indicator'
                  isInvalid={Boolean(errors.singleIndicatorValue)}
                  options={inputIndicator.map((item: any) => ({
                    value: item?.id,
                    label: item?.name,
                  }))}
                  onChange={(id) => setFieldValue('singleIndicatorValue', id)}
                />
                <ErrorMessage name='singleIndicatorValue' component={FieldError} />
              </>
            )}
            {inputIndicator?.length === 0 && (
              <Text {...PLAN_TEXT.body} color={colors.danger}>
                No input indicators
              </Text>
            )}

            <StepFooterRow>
              <ActionStepFooter
                nextButtonName='Continue'
                prevButtonName='Previous'
                isSubmitting={isSubmitting}
                disableNext={inputIndicator?.length === 0}
              />
            </StepFooterRow>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SingleIndWoCol;
